import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import { Field } from 'redux-form';
import CheckBox, { CHECKBOX_LABEL_STYLE } from '../../../shared-components/CheckBox/CheckBox';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';
import PopupLink from '../../../shared-components/PopupLink/PopupLink';
import { scrollToBottom } from './AgreementCheckboxUtils';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import _ from 'lodash';

import './AgreementCheckbox.less';
import Icon, { ICON_TYPE } from '../../../shared-components/Icon/Icon';


const LOCALE_PREFIX = 'GB/components/AgreementCheckbox/AgreementCheckbox';

export class AgreementCheckbox extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
        agreementType: PropTypes.oneOf(['secci', 'credit']).isRequired,
        agreementChecked: PropTypes.bool,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)).isRequired,
        scrollToBottomOnCheck: PropTypes.bool.isRequired
    };

    static defaultProps = {
        agreementChecked: false,
        scrollToBottomOnCheck: true
    };

    state = {
        showPDF: this.props.agreementChecked
    };

    componentDidUpdate(prevProps, prevState) {
        const { showPDF } = this.state;
        const { scrollToBottomOnCheck } = this.props;
        if (showPDF === true && prevState.showPDF === false && scrollToBottomOnCheck) {
            scrollToBottom(window, 1000);
        }
    }

    toggleShowPDF = () => {
        this.setState({
            showPDF: !this.state.showPDF
        });
    };

    render() {
        const {
            agreementType,
            flow,
            intl
        } = this.props;

        const agreementNameMap = {
            secci : 'Secci',
            credit : 'Credit'
        };

        const agreementName = agreementNameMap[agreementType];

        let agreementpdfLink;
        let PDF;

        const agreementpdfLinkMessage = <FormattedMessage id={`${LOCALE_PREFIX}.${agreementType}PDF`} />;

        if (flow !== FLOW_TYPE.VENICE) {
            agreementpdfLink = (
                <PopupLink
                    id={`download${agreementName}`}
                    url={`${agreementType}Contract`}
                    className="pdfLink popup"
                    name={`${agreementType}PDF`}
                >
                    {agreementpdfLinkMessage}
                </PopupLink>);
        } else {
            agreementpdfLink = (
                <a
                    id={`download${agreementName}`}
                    href={`${agreementType}Contract`}
                    className="pdfLink"
                >
                    {agreementpdfLinkMessage}
                </a>);
        }

        const checkboxLabel = this.state.showPDF ? (
            <React.Fragment>
                <span>
                    <FormattedMessage id={`${LOCALE_PREFIX}.${agreementName}Confirm`} />
                </span>
                <div id="agreementPDF" className="agreementPDF vx_text-body-sm_medium">
                    <Icon type={ICON_TYPE.PDF} className="agreementPDF-icon" />
                    {agreementpdfLink}
                </div>
            </React.Fragment>
        ) : (
            <span>
                <FormattedMessage id={`${LOCALE_PREFIX}.${agreementName}Confirm`} />
            </span>
        );

        const checkbox = (
            <Field
                id={`agreeToRead${agreementName}`}
                name={`agreeToRead${agreementName}`}
                label={checkboxLabel}
                labelStyle={CHECKBOX_LABEL_STYLE.NORMAL}
                component={CheckBox}
                allowErrorPopout={true}
                onChange={this.toggleShowPDF}
                validate={isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.agree${agreementName}Error`}))}
            />
        );


        return (
            <div className="AgreementCheckbox">
                {checkbox}
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    flow: _.get(state, 'serverData.flow')
});

export default connect(mapStateToProps)(injectIntl(AgreementCheckbox));
